import { ProducerConsumerException } from "./producer-consumer.exception";

/**
 * Exception when a parameter is invalid for a read function
 */
export class ProducerConsumerInvalidReadParameterException extends ProducerConsumerException {}
